var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.213 12C20.213 7.91891 16.9047 4.61054 12.8236 4.61054C9.5582 4.61054 6.78612 6.72932 5.80962 9.6673C7.21848 9.68197 8.44769 9.17445 9.54342 8.1306C9.90045 7.79047 10.4656 7.80417 10.8057 8.16121C11.1459 8.51824 11.1322 9.0834 10.7751 9.42352C9.06471 11.053 7.01109 11.708 4.69364 11.3643C4.63589 11.365 4.57724 11.3601 4.51829 11.3491C4.28841 11.3062 4.09567 11.1787 3.96617 11.0049C2.34655 9.26791 1.72151 7.1818 2.11613 4.82838C2.19768 4.34207 2.65803 4.01394 3.14435 4.09548C3.63067 4.17702 3.95881 4.63738 3.87725 5.1237C3.66834 6.3696 3.82107 7.48304 4.34368 8.49087C5.72165 5.16465 8.99868 2.82483 12.8236 2.82483C17.8909 2.82483 21.9987 6.93268 21.9987 12C21.9987 17.0673 17.8909 21.1751 12.8236 21.1751C8.93194 21.1751 5.60829 18.7526 4.27421 15.3365C4.09484 14.8772 4.32178 14.3594 4.78111 14.18C5.24044 14.0007 5.75821 14.2276 5.93758 14.6869C7.01311 17.441 9.6919 19.3894 12.8236 19.3894C16.9047 19.3894 20.213 16.0811 20.213 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.bac3ca00.svg";
export { ForwardRef as ReactComponent };